import { TopWriterBySalesTable } from './TopWriterBySalesTable'
import { withTopWriterBySalesTable } from './withTopWriterBySalesTable'

const Connected = withTopWriterBySalesTable(TopWriterBySalesTable)

export { Connected as TopWriterBySalesTable }
